import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { CtrlBaseComponent } from '..';
import { ADN_PLUS } from '../../models';
import { CtFormComponent } from '../ct-form/ct-form.component';

@Component({
  selector: 'ct-form-list',
  templateUrl: './ct-form-list.component.html',
  styleUrls: ['./ct-form-list.component.css']
})
export class CtFormListComponent extends CtrlBaseComponent implements AfterViewInit {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;

  private adnList: Array<ADN_PLUS> = [];

  private actionDefintion = {
    "displayName": null,
    "eventName": "onClick",
    "actionKey": null,
    "type": 3,
    "action": "",
    "isAsync": false,
    "actionParams": [],
    "conditionParams": [],
    "utilParams": [],
    "preAction": null,
    "postAction": {},
    "params": [],
    "actionsFlow": null,
    "Entity": null,
    "Operation": "",
    "Endpoint": null
  };

  private childModels = [
    {
      "ctType": "CtColumn",
      "controlProperties": {
        "hidden": false,
        "title": "",
        "size": 4,
        "id": "col_frmLst_0",
        "styleClass": "px-1"
      },
      "controlActions": [],
      "models": [
        {
          "ctType": "CtPanel",
          "controlProperties": {
            "hidden": false,
            "listenedComponentId": "",
            "listenedProperty": "",
            "styleClass": "my-2",
            "id": "pnl_frmLst_",
            "modelId": ""
          },
          "controlActions": [],
          "models": [
            {
              "ctType": "CtHeader",
              "controlProperties": {
                "hidden": false,
                "listenedComponentId": "",
                "listenedProperty": "",
                "styleClass": "d-block pb-0 border-0",
                "id": "pnlH_frmLst_",
                "modelId": ""
              },
              "controlActions": [],
              "models": [

                {
                  "ctType": "CtButton",
                  "controlProperties": {
                    "hidden": false,
                    "listenedComponentId": "",
                    "listenedProperty": "",
                    "disabled": false,
                    "id": "btnCtButton_left",
                    "modelId": "",
                    "pickId": "",
                    "buttonColor": "",
                    "buttonText": "",
                    "icon": "",
                    "btnBlock": false,
                    "styleClass": "float-left va-starbtn",
                    "eventRef": ""
                  },
                  "controlActions": [],
                  "models": []
                },
                {
                  "ctType": "CtButton",
                  "controlProperties": {
                    "hidden": false,
                    "listenedComponentId": "",
                    "listenedProperty": "",
                    "disabled": false,
                    "id": "btnCtButton_right",
                    "modelId": "",
                    "pickId": "",
                    "buttonColor": "",
                    "buttonText": "",
                    "icon": "",
                    "btnBlock": false,
                    "styleClass": "float-right va-checkbtn",
                    "eventRef": ""
                  },
                  "controlActions": [],
                  "models": []
                },
                {
                  "ctType": "CtButton",
                  "controlProperties": {
                    "hidden": false,
                    "listenedComponentId": "",
                    "listenedProperty": "",
                    "disabled": false,
                    "id": "btnCtButton_top",
                    "modelId": "",
                    "pickId": "",
                    "buttonColor": "",
                    "buttonText": "",
                    "icon": "",
                    "btnBlock": false,
                    "styleClass": "float-right va-checkbtn",
                    "eventRef": ""
                  },
                  "controlActions": [],
                  "models": []
                }
              ]
            },
            {
              "ctType": "CtForm",
              "controlProperties": {
                "hidden": false,
                "listenedComponentId": "",
                "listenedProperty": "",
                "autoDisabled": false,
                "cleanFormButton": false,
                "readOnly": false,
                "styleClass": "p-3",
                "panelType": "normal",
                "id": "frmList_",
                "modelId": ""
              },
              "controlActions": [],
              "models": []
            },
            {
              "ctType": "CtHeader",
              "controlProperties": {
                "hidden": false,
                "listenedComponentId": "",
                "listenedProperty": "",
                "styleClass": "flex-column",
                "id": "pnlF_frmLst_",
                "modelId": ""
              },
              "controlActions": [],
              "models": []
            }
          ]
        }
      ]
    }


  ]

  private selectedFormInstace: CtFormComponent;

  private selectedPanelIndex: number;

  private actionButtons;

  private formInntaces;

  constructor() {
    super();
  }


  ngAfterViewInit(): void {
    this.paintForms();
  }

  paintForms() {
    //Push form models provideed from editor
    this.childModels[0].models[0].models[1].models = JSON.parse(JSON.stringify(this.getMetaData().models));
    //Push btn models
    if (this.actionButtons)
      this.childModels[0].models[0].models[2].models = JSON.parse(JSON.stringify(this.actionButtons));

    let newFormArray = [];

    for (let i = 0; i < this.adnList.length; i++) {
      //Construye un modelo para cada uno delos ADNS de la lista
      let col = JSON.parse(JSON.stringify(this.childModels[0]));

      let panel = col.models[0];
      let header = panel.models[0];
      let form = panel.models[1];
      let footer = panel.models[2];

      col.controlProperties.id = (this.getId() + '_' + col.controlProperties.id + i);

      panel.controlProperties.id = (this.getId() + '_' + panel.controlProperties.id + i);

      header.controlProperties.id = (this.getId() + '_' + header.controlProperties.id + i);

      form.controlProperties.id = (this.getId() + '_' + form.controlProperties.id + i);
      //El footer necesita incluir los botones
      footer.controlProperties.id = (this.getId() + '_' + footer.controlProperties.id + i);

      if (this.actionButtons) {
        for (let x = 0; x < footer.models.length; x++) {
          footer.models[x].controlProperties.id = (this.getId() + '_' + footer.models[x].controlProperties.id + '_' + i + '_' + x);
          let newAction = JSON.parse(JSON.stringify(this.actionDefintion))
          newAction.actionParams = []
          newAction.action = this.getId() + ".onBtnClick";
          newAction.Operation = this.getId() + ".onBtnClick";
          //El boton siempre va en la pos 0
          newAction.actionParams.push(footer.models[x].controlProperties.id);
          newAction.actionParams.push(form.controlProperties.id);
          footer.models[x].controlActions.push(newAction);
        }
      }

      for (let f = 0; f < header.models.length; f++) {
        header.models[f].controlProperties.id = (this.getId() + '_' + header.models[f].controlProperties.id + '_' + i + '_' + f);
        let newAction = JSON.parse(JSON.stringify(this.actionDefintion))
        newAction.actionParams = []
        newAction.action = this.getId() + ".onBtnClick";
        newAction.Operation = this.getId() + ".onBtnClick";
        //El boton siempre va en la pos 0
        newAction.actionParams.push(header.models[f].controlProperties.id);
        newAction.actionParams.push(form.controlProperties.id);
        header.models[f].controlActions.push(newAction);
      }

      for (let j = 0; j < form.models.length; j++) {
        form.models[j].controlProperties.id = (form.models[j].controlProperties.id + '_' + i + '_' + j);
      }

      newFormArray.push(col);
    }

    let newMeta = JSON.parse(JSON.stringify(this.getMetaData()));
    newMeta.models = newFormArray;
    this.childElements = [];
    this.formInntaces = this.paintChildren(newMeta, this.target);

    for (let i = 0; i < this.formInntaces.length; i++) {
      (<CtFormComponent>this.formInntaces[i].childElements[0].childElements[1]).updateBindingAdn(this.adnList[i]);
    }

  }

  bindBtnActions() {

  }

  onBtnClick(e, r) {
    let btn = this.utilService.getComponentRef(e.actionParams[0]);
    this.selectedFormInstace = <CtFormComponent>this.utilService.getComponentRef(e.actionParams[1]);
    this.selectedPanelIndex = e.actionParams[1].charAt(e.actionParams[1].length - 1);
    if (btn.eventRef) {
      this.event2(btn.eventRef);
    }
  }

  onRefresh() {
    this.selectedFormInstace = null;
    this.formInntaces = null;
    this.event2('onRefresh');
  }

  setAdnList(adnList: Array<ADN_PLUS>) { this.adnList = adnList }
  setActionButtons(actionButtons: Array<any>) { this.actionButtons = actionButtons }
  getAdnList(): Array<ADN_PLUS> { return this.adnList }
  getActionButtons(): Array<any> { return this.actionButtons }
  getSelectedFormBindingAdn() { return this.selectedFormInstace.getBindingAdn() }

}
